import { useState } from "react";
import { createContext } from "react";

export const FunctionContext = createContext({
    currentFunctionCode: {
        code: '',
        name: '',
        path: '',
        type: '',
        url: '',
    },
    setFunctionCode: () => null,
}
);

export const FunctionProvider = ({children}) => {
    const [currentFunctionCode, setFunctionCode] = useState(null);
    const value = {currentFunctionCode, setFunctionCode};
    return <FunctionContext.Provider value={value}>{children}</FunctionContext.Provider>
};

